import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations } from 'vuexfire';
import Firebase from '../firebase.js';
import router from "../router";

Vue.use(Vuex);

const db = Firebase.db;

export const store = new Vuex.Store({
  state: {
    devMode: false,
    superAdmin: false,
    formValidationBypass: false,
    loggedIn: null,
    signingIn: false,
    accountID: null,
    unknownUser: false,
    userData: {
      email: null,
      fullName: null,
      googleData: {},
    },
    propertyLoading: true,
    propertiesLoading: true,
    propertyID: null,
    property: {},
    propertyRent: {},
    properties: {},
    propertiesRent: {},
    propertiesRentLoading: true,

    reminderLoading: true,
    remindersLoading: true,
    reminderID: null,
    reminder: {},
    reminders: {},

    maintenanceRequestLoading: true,
    maintenanceRequestsLoading: true,
    maintenanceRequestID: null,
    maintenanceRequest: {},
    maintenanceRequests: {},

    snackbar:{
      color: '',
      text: '',
    },

  },
  getters: {
    authenticated: state => {
      return state.user.loggedIn;
    },
    formValidationBypass: state => {
      return state.formValidationBypass;
    },
    signingIn: state => {
      return state.signingIn;
    },
    unknownUser: state => {
      return state.unknownUser;
    },
    propertyLoading: state => {
      return state.propertyLoading;
    },
    propertiesLoading: state => {
      return state.propertiesLoading;
    },
    propertiesRentLoading: state => {
      return state.propertiesRentLoading;
    },
    reminderLoading: state => {
      return state.reminderLoading;
    },
    remindersLoading: state => {
      return state.remindersLoading;
    },
    maintenanceRequestLoading: state => {
      return state.maintenanceRequestLoading;
    },
    maintenanceRequestsLoading: state => {
      return state.maintenanceRequestsLoading;
    },
    accountID: state => {
      return state.accountID;
    },
    loggedIn: state => {
      return state.loggedIn;
    },
    userName: state => {
      return state.userData.fullName;
    },
    userFirstName: state => {
      if (state.userData.fullName){
        const name = state.userData.fullName.split(' ');
        return name[0];
      }
      return null;
    },
    userLastName: state => {
      if (state.userData.fullName){
        const name = state.userData.fullName.split(' ');
        return name[1];
      }
      return null;
    },
    devMode: state => {
      return state.devMode;
    },
    superAdmin: state => {
      return state.superAdmin;
    },

    properties: state => {
      return state.properties;
    },
    propertiesRent: state => {
      return state.propertiesRent;
    },
    reminders: state => {
      return state.reminders;
    },
    maintenanceRequests: state => {
      return state.maintenanceRequests;
    },

    property: state => {
      return state.property;
    },
    reminder: state => {
      return state.reminder;
    },
    maintenanceRequest: state => {
      return state.maintenanceRequest;
    },

    propertyID: state => {
      return state.propertyID;
    },
    reminderID: state => {
      return state.reminderID;
    },
    maintenanceRequestID: state => {
      return state.maintenanceRequestID;
    },

    propertyAddressLineOne: state => {
      return state.property.addressLineOne;
    },
    propertyCity: state => {
      return state.property.city;
    },
    propertyState: state => {
      return state.property.state;
    },
    propertyZip: state => {
      return state.property.zip;
    },
    propertyTenantFirstName: state => {
      return state.property.tenantFirstName ?? null;
    },
    propertyTenantLastName: state => {
      return state.property.tenantLastName ?? null;
    },
    propertyTenantFullName: state => {
      return `${state.property.tenantFirstName} ${state.property.tenantLastName}` ?? null;
    },
    propertyTenantEmail: state => {
      return state.property.tenantEmail ?? null;
    },
    propertyTenantPhone: state => {
      return state.property.tenantPhone ?? null;
    },
    propertyTenantCellPhone: state => {
      return state.property.tenantCellPhone ?? null;
    },
    propertyStartDate: state => {
      return state.property.startDate ?? null;
    },
    propertyRent: state => {
      return state.propertyRent ?? {};
    },

    snackbar: state => {
      return state.snackbar;
    },

  },
  mutations: {
    toggleDevMode (state) {
      state.devMode = !state.devMode;
    },
    setFormValidationBypass (state, payload) {
      state.formValidationBypass = payload;
    },
    setSigningIn (state, payload) {
      state.signingIn = payload;
    },
    setUnknownUser (state, payload) {
      state.unknownUser = payload;
    },
    setPropertyLoading (state, payload) {
      state.propertyLoading = payload;
    },
    setPropertiesLoading (state, payload) {
      state.propertiesLoading = payload;
    },
    setPropertiesRentLoading (state, payload) {
      state.propertiesRentLoading = payload;
    },

    setReminderLoading (state, payload) {
      state.reminderLoading = payload;
    },
    setRemindersLoading (state, payload) {
      state.remindersLoading = payload;
    },

    setMaintenanceRequestLoading (state, payload) {
      state.maintenanceRequestLoading = payload;
    },
    setMaintenanceRequestsLoading (state, payload) {
      state.maintenanceRequestsLoading = payload;
    },

    setUserLoginState (state, payload) {
      state.user.loggedIn = payload;
    },
    setUserData (state, payload) {
      state.userData = payload;
    },
    setSuperAdmin (state, payload) {
      state.superAdmin = payload;
    },
    setAccountID (state, payload) {
      state.accountID = payload;
      state.loggedIn = true;
    },
    clearAccount (state) {
      state.accountID = null;
      state.userData.email = null;
      state.userData.fullName = null;
      state.loggedIn = false;
      state.unknownUser = false;
    },
    setProperties (state, payload) {
      state.properties = payload;
    },
    setPropertiesRent (state, payload) {
      state.propertiesRent = payload;
    },
    setReminders (state, payload) {
      state.reminders = payload;
    },
    setMaintenanceRequests (state, payload) {
      state.maintenanceRequests = payload;
    },

    setProperty (state, payload) {
      state.property = payload;
    },
    setPropertyRent (state, payload) {
      state.propertyRent = payload;
    },
    setPropertyID (state, payload) {
      state.propertyID = payload;
    },

    setReminder (state, payload) {
      state.reminder = payload;
    },
    setReminderID (state, payload) {
      state.reminderID = payload;
    },

    setMaintenanceRequest (state, payload) {
      state.maintenanceRequest = payload;
    },
    setMaintenanceRequestID (state, payload) {
      state.maintenanceRequestID = payload;
    },

    setSnackbar (state, payload) {
      state.snackbar = payload;
    },

    ...vuexfireMutations,
  },
  actions: {
    toggleDevMode ({commit, state}) {
      if (state.superAdmin){
        commit('toggleDevMode');
      }
    },
    setPropertyLoading ({commit}, payload) {
      commit('setPropertyLoading', payload);
    },
    setPropertyRent ({commit}, payload) {
      commit('setPropertyRent', payload);
    },
    setPropertiesLoading ({commit}, payload) {
      commit('setPropertiesLoading', payload);
    },
    setReminderLoading ({commit}, payload) {
      commit('setReminderLoading', payload);
    },
    setRemindersLoading ({commit}, payload) {
      commit('setRemindersLoading', payload);
    },
    setMaintenanceRequestLoading ({commit}, payload) {
      commit('setMaintenanceRequestLoading', payload);
    },
    setMaintenanceRequestsLoading ({commit}, payload) {
      commit('setMaintenanceRequestsLoading', payload);
    },
    setUserLoginState ({commit}, payload) {
      commit('setUserLoginState', payload);
    },
    setAccountID ({commit}, payload) {
      commit('setAccountID', payload);
    },
    setUserData ({commit}, payload) {
      commit('setUserData', payload);
    },
    setSnackbar ({commit}, payload) {
      commit('setSnackbar', payload);
    },
    clearProperty( {commit}) {
      commit('setPropertyID', null);
      commit('setProperty', {});
    },
    clearReminder( {commit}) {
      commit('setReminderID', null);
      commit('setReminder', {});
    },
    clearMaintenanceRequest( {commit}) {
      commit('setMaintenanceRequestID', null);
      commit('setMaintenanceRequest', {});
    },

    //SETTERS
    async setAccount({commit}, payload ){
      commit('setAccountID', payload.accountID);
      commit('setSuperAdmin', payload.superAdmin);
      commit('setUserData', payload.data);
    },

    async logout({commit} ){
      await Firebase.logout();
      commit('clearAccount');
      await router.push('/login');
    },

    //Properties
    async addNewProperty({dispatch, state}, payload){
      try{
        const result = await db.collection('properties').add({
          propertyData: payload,
          rent: {},
          accountID: state.accountID
        });
        if (result.id){
          await dispatch('setProperty', result.id);
          //Update List  State
          await dispatch('setProperties');
          await dispatch('setSnackbar', {
            text: `New property added!`,
            color: 'success',
          });
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async deleteAssociatedItems({dispatch, state}, payload) {
      try {
        //Delete Reminders
        const remindersRef = await db.collection('reminders').where('accountID', '==', state.accountID).where('propertyID', '==', payload);
        const remindersSnapshot = await remindersRef.get();
        if (!remindersSnapshot.empty) {
          remindersSnapshot.forEach(doc => {
            // console.log('found reminder: '+doc.id);
            dispatch('deleteReminder', doc.id);
          });
        }
        //Delete Requests
        const requestsRef = await db.collection('maintenanceRequests').where('accountID', '==', state.accountID).where('propertyID', '==', payload);
        const requestsSnapshot = await requestsRef.get();
        if (!requestsSnapshot.empty) {
          requestsSnapshot.forEach(doc => {
            // console.log('found maintenanceRequest: '+doc.id);
            dispatch('deleteMaintenanceRequest', doc.id);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async deleteProperty({dispatch, state}, payload){
      try {
        await dispatch('deleteAssociatedItems', payload)
        await db.collection('properties').doc(payload).delete();
        if (payload === state.propertyID){
          dispatch('clearProperty');
          await router.push('/properties');
        }
        //Update List State
        dispatch('setProperties');
        await dispatch('setSnackbar', {
          text: `Property deleted!`,
          color: 'success',
        });
      } catch (e) {
        console.log(e);
      }
    },
    async updateProperty({dispatch, state}, payload){
      try{
        await db.collection('properties').doc(state.propertyID)
          .update({
            propertyData: payload
          });
        //Update Reminder State
        await dispatch('setProperty', state.propertyID);
        //Update Reminders State
        await dispatch('setProperties');
        await dispatch('setSnackbar', {
          text: `Property Updated!`,
          color: 'success',
        });

      } catch (e) {
        console.log(e);
      }
    },
    async setProperty({commit}, payload ){
      commit('setPropertyLoading', true);
      const propertyRef = db.collection('properties').doc(payload);
      const snapshot = await propertyRef.get();
      if (!snapshot.empty) {
        const result = snapshot.data();
        commit('setPropertyID', payload);
        commit('setPropertyRent', result.rent);
        commit('setProperty', result.propertyData);
      }
      commit('setPropertyLoading', false);
    },
    async setProperties({commit,state} ){
      commit('setPropertiesLoading', true);
      const propertiesRef = db.collection('properties').where('accountID', '==', state.accountID);
      const snapshot = await propertiesRef.get();
      let items = {};
      if (!snapshot.empty) {
        snapshot.forEach(doc => {
          const values = doc.data();
          items[doc.id] = values.propertyData;
        });
      }
      commit('setProperties', items);
      commit('setPropertiesLoading', false);
    },

    async setPropertiesRent({commit,state} ){
      commit('setPropertiesRentLoading', true);
      const ref = db.collection('properties').where('accountID', '==', state.accountID);
      const snapshot = await ref.get();
      let items = {};
      if (!snapshot.empty) {
        snapshot.forEach(doc => {
          const values = doc.data();
          items[doc.id] = values.rent;
        });
      }
      commit('setPropertiesRent', items);
      commit('setPropertiesRentLoading', false);
    },

    //Reminders
    async setReminder({dispatch, commit}, payload ){
      commit('setReminderLoading', true);
      if (payload !== null){
        const ref = db.collection('reminders').doc(payload);
        const snapshot = await ref.get();
        if (snapshot.exists) {
          const result = snapshot.data();
          commit('setReminderID', payload);
          commit('setReminder', result);
        }
      } else {
        await dispatch('clearReminder');
      }
      commit('setReminderLoading', false);

    },
    async setReminders({commit,state} ){
      commit('setRemindersLoading', true);
      const ref = db.collection('reminders').where('accountID', '==', state.accountID).orderBy('date', 'desc');
      const snapshot = await ref.get();
      let items = {};
      if (!snapshot.empty) {
        snapshot.forEach(doc => {
          items[doc.id] = doc.data();
        });
      }
      commit('setReminders', items);
      commit('setRemindersLoading', false);
    },
    async addNewReminder({dispatch}, payload){
      try{
        const result = await db.collection('reminders').add(payload);
        if (result.id){
          //could add an updated message here
          await dispatch('setReminder', result.id);
          //Update Reminders State
          await dispatch('setReminders');
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async deleteReminder({dispatch, state}, payload){
      try {
        await db.collection('reminders').doc(payload).delete();
        if (payload === state.reminderID){
          dispatch('clearReminder');
          await router.push('/reminders');
        }
        //Update List State
        dispatch('setReminders');
        await dispatch('setSnackbar', {
          text: `Reminder Deleted!`,
          color: 'success',
        });
      } catch (e) {
        console.log(e);
      }
    },
    async updateReminder({dispatch, state}, payload){
      try{
        await db.collection('reminders').doc(state.reminderID)
          .update(payload);
        //Update Reminder State
        await dispatch('setReminder', state.reminderID);
        //Update Reminders State
        await dispatch('setReminders');
      } catch (e) {
        console.log(e);
      }
    },
    async toggleReminderCompletion({dispatch, state}, payload){
      try{
        const completionStatus = !state.reminders[payload].complete;
        await db.collection('reminders').doc(payload)
          .update({complete: completionStatus});
        if (payload === state.reminderID){
          //Update Reminder State
          await dispatch('setReminder', state.reminderID);
        }
        //Update Reminders State
        await dispatch('setReminders');
        await dispatch('setSnackbar', {
          status: true,
          text: `Reminder marked as ${completionStatus ? 'Completed' : 'Incomplete'}`,
          color: completionStatus ? 'success' : 'grey',
        });
      } catch (e) {
        console.log(e);
      }
    },

    //Maintenance Requests
    async setMaintenanceRequest({dispatch, commit}, payload ){
      commit('setMaintenanceRequestLoading', true);
      if (payload !== null){
        const ref = db.collection('maintenanceRequests').doc(payload);
        const snapshot = await ref.get();
        if (snapshot.exists) {
          const result = snapshot.data();
          commit('setMaintenanceRequestID', payload);
          commit('setMaintenanceRequest', result);
        }
      } else {
        await dispatch('clearMaintenanceRequest');
      }
      commit('setMaintenanceRequestLoading', false);

    },
    async setMaintenanceRequests({commit,state} ){
      commit('setMaintenanceRequestsLoading', true);
      const ref = db.collection('maintenanceRequests').where('accountID', '==', state.accountID).orderBy('date', 'desc');
      const snapshot = await ref.get();
      let items = {};
      if (!snapshot.empty) {
        snapshot.forEach(doc => {
          items[doc.id] = doc.data();
        });
      }
      commit('setMaintenanceRequests', items);
      commit('setMaintenanceRequestsLoading', false);
    },
    async addNewMaintenanceRequest({dispatch}, payload){
      try{
        const result = await db.collection('maintenanceRequests').add(payload);
        if (result.id){
          await dispatch('setMaintenanceRequest', result.id);
          await dispatch('setMaintenanceRequests');
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async deleteMaintenanceRequest({dispatch, state}, payload){
      try {
        await db.collection('maintenanceRequests').doc(payload).delete();
        if (payload === state.maintenanceRequestID){
          dispatch('clearMaintenanceRequest');
          await router.push('/maintenance-requests');
        }
        //Update List State
        dispatch('setMaintenanceRequests');
        await dispatch('setSnackbar', {
          text: `Maintenance Request Deleted!`,
          color: 'success',
        });
      } catch (e) {
        console.log(e);
      }
    },
    async updateMaintenanceRequest({dispatch, state}, payload){
      try{
        await db.collection('maintenanceRequests').doc(state.maintenanceRequestID)
          .update(payload);
        //Update Reminder State
        await dispatch('setMaintenanceRequest', state.maintenanceRequestID);
        //Update List State
        await dispatch('setMaintenanceRequests');
      } catch (e) {
        console.log(e);
      }
    },
    async toggleMaintenanceRequestCompletion({dispatch, state}, payload){
      try{
        const completionStatus = !state.maintenanceRequests[payload].complete;
        await db.collection('maintenanceRequests').doc(payload)
          .update({complete: completionStatus});
        if (payload === state.maintenanceRequestID){
          //Update Reminder State
          await dispatch('setMaintenanceRequest', state.maintenanceRequestID);
        }
        //Update List State
        await dispatch('setMaintenanceRequests');

        await dispatch('setSnackbar', {
          text: `Maintenance request marked as ${completionStatus ? 'complete' : 'incomplete'}!`,
          color: 'success',
        });
      } catch (e) {
        console.log(e);
      }
    },


    async updatePropertyRent({dispatch, state}, payload){
      try{
        await db.collection('properties').doc(state.propertyID)
          .update({
            rent: payload
          });
        //Update Reminder State
        await dispatch('setProperty', state.propertyID);
        //Update Reminders State
        await dispatch('setProperties');
        await dispatch('setSnackbar', {
          text: `Rent Payments Updated!`,
          color: 'success',
        });

      } catch (e) {
        console.log(e);
      }
    },

    async loadUserData({ dispatch, commit }, user) {
      commit('setSigningIn', true);
      let accountFound = false;

      const userAccount = await db.collection('users').doc(user.email).get();
      if (userAccount.exists) {
        console.log('user exists')
        const accountID = userAccount.data().accountID;
        const account = await db.collection('accounts').doc(accountID).get();
        if (account.exists) {
          accountFound = true;
          let superAdmin = account.data().superAdmin;
          Firebase.fbAnalytics.setUserId(user.uid);
          Firebase.fbAnalytics.setUserProperties(superAdmin);
          await dispatch('setAccount', {
            accountID,
            superAdmin,
            data: {
              email: user.email,
              fullName: user.displayName,
            }
          });
          commit('setUnknownUser', false);
        }
      } else {
        commit('setUnknownUser', user.email)
        Firebase.logout();
      }

      if (accountFound) {
        await dispatch('initialAppLoad');
        if (router.currentRoute.path === '/login') {
          router.push('/')
        }
      }
      commit('setSigningIn', false);

    },


    async initialAppLoad({dispatch, state}){
      if (state.accountID){
        await dispatch('setProperties').then((result) => {
          return result;
        });
        await dispatch('setPropertiesRent').then((result) => {
          return result;
        });
        await dispatch('setReminders').then((result) => {
          return result;
        });
        await dispatch('setMaintenanceRequests').then((result) => {
          return result;
        });
      }
    },

  }
});
